export default {
    // Sidebar
    'Nova OS Proativa':  'New Proactive WO',
    'Interno':  'Internal',
    'Externo':  "External",
    'Preventiva':  "Preventive",
    'Preventiva Programada':  "Scheduled Preventive",
    "Preventiva Programada Armazém": "Scheduled Preventive Warehouse",
    'Reaberta':  "Reopened",
    'Execuções':  "Executions",
    'Armazém':  "Warehouse",
    'Frota':  "Fleet",
    'Sair':  "Logout",
    'Inventário':  "Inventory",

    // Nova Os
    'Voltar':  "Back",
    'Nova OS':  "New WO",
    'Operação':  "Operation",
    'Placa':  "Plate",
    'Segmento':  "Segment",
    'Problemas':  "Issues",
    'Descrição do Problema':  "Issue Description",
    'Gerar OS':  "Generate WO",
    'Cancelar':  "Cancel",

    // OS Interna
    "Nenhum resultado encontrado": "No results found",
    "Exibindo resultado": "Showing result",
    "de": "of",
    "Aberta há": "Open for",
    "Concluída em": "Completed on",
    "Falha ao carregar os dados da OS": "Failed to load WO data",
    "Falha ao carregar os itens da OS": "Failed to load WO items",

    // Ordem Servico
    "Detalhes": "Details",
    "Mostrar": "Show",
    "Esconder": "Hide",
    "Telefone": "Phone",
    "Data": "Date",
    "Início": "Start",
    "Final": "End",
    "Fornecedor": "Supplier",
    "Tipo": "Type",
    "Ciclo preventiva": "Preventive cycle",
    "Criticidade": "Criticality",
    "Previsão de Atendimento": "Estimated Service Time",
    "Atendimento do Item": "Item Service",
    "Observações": "Notes",
    "Imagens": "Images",
    "Salvar": "Save",
    "Ordens de Serviço": "Work Orders",
    "GERADA_CHECKLIST": "GENERATED FROM CHECKLIST",
    "OBS_CHECKLIST": "CHECKLIST NOTES:",
    "OS_INTERNA": "INTERNAL WO:",

    // OS Item
    "Iniciar": "Start",
    "Ações": "Actions",
    "Continuar": "Continue",
    "Pausar": "Pause",
    "Registrar Peças": "Register Parts",
    "Cancelar OS": "Cancel WO",
    "OS Externa": "External WO",
    "Insira um serviço. Tente novamente.": "Insert a service. Try again.",

    // ModalItems
    "Serviços": "Services",
    "SERVIÇOS": 'SERVICES',
    "Observação": "Note",
    "Anexo de arquivos": "File attachment",
    "Informe o valor total dos serviços/peças": "Enter the total value of services/parts",
    "Informe o motivo do socorro em rota": "Enter the reason for roadside assistance",
    "Informe o pneu utilizado neste serviço": "Enter the tire used in this service",
    "Foi trocado o pneu": "Was the tire replaced",
    "Finalizar OS": "Finish WO",

    // Modal se foi utilizado peças
    "Foi utilizado Peças?": "Were parts used?",
    'Se foi utilizado peças neste atendimento, pressione "Sim" na opção abaixo!': "If parts were used in this service, press 'Yes' below!",
    "Não": "No",
    "Sim": "Yes",

    // Modal Itens Fim
    "Informe os itens utilizados neste serviço": "Enter the items used in this service",
    "Fechar": "Close",
    "Peças": "Parts",
    "Peça": "Part",
    "Quantidade": "Quantity",
    "Preço": "Price",
    "Informe o pneu novo": "Enter the new tire",
    
    //Modal Pause
    "Informe a Justificativa": "Enter the justification",
    "Confirmar Pausa": "Confirm Pause",
    "Justificativa": 'Justification',
    "Ir ao banheiro": 'Bathroom break',
    "Fim de expediente": 'End of shift',
    "Atendimento": 'Service',
    "Refeição": 'Meal break',
    "Aguardando Peças": 'Waiting for parts',
    "Auxílio externo": 'External assistance',
    'Selecione qual peça está aguardando': 'Select which part is pending',

    // Confirmar OS Externa
    "Confirmar OS Externa": "Confirm External WO",
    "Deseja realmente enviar OS": "Do you really want to submit the WO",
    "Confirmar": "Confirm",

    // Lista de Execucao
    "Lista de execução": "Execution List",
    "Nenhuma execução ativa": "No active executions",
    "Início Atendimento": "Start Service",
    "Encerrar OS": "Close WO",
    "Acessar OS": "Access WO",
    "Colaborador": "Employee",
    "Execuções em Pause": "Paused Executions",
    "Nenhuma execução em pause": "No paused executions",

    // Login
    "Torne sua rotina mais dinâmica": "Make your routine more dynamic",
    "ACESSO AO SISTEMA": "SYSTEM ACCESS",
    "Terminal Oficina": "Workshop Terminal",
    "Realize o login e tenha acesso ao controle": "Log in and access control",
    "e gestão de suas Ordens de Serviço": "and management of your Work Orders",
    "Mecânico Externo": "External Mechanic",
    "Acessar": "Access",
    "Falha ao fazer login": "Login failed",

    // Filtro Internas
    "Ordenar": "Sort",
    "Antigas Primeiro": "Oldest First",
    "Recentes Primeiro": "Newest First",
    "Maior": "Higher",
    "Menor": "Lower",
    "Segmentos": "Segments",
    "Período": "Period",
    "Execução": "Execution",
    "Todos": "All",
    "Pendentes": "Pending",
    "Finalizadas": "Completed",
    "Aplicar filtro": "Apply filter",
    "Limpar filtros": "Clear filters",
    "Esconder filtros": "Hide filters",
    "Criado por": "Created by",
    "Usuário": "User",
    "Ação": "Action",

    // Os Preventivas
    "Filtre as OS Preventivas": "Filter Preventive WOs",
    "Preventivas Vencidas": "Overdue Preventives",
    "Preventivas à Vencer": "Upcoming Preventives",
    "Carrocerias Vencidas": "Overdue Bodyworks",
    "Atualizar": "Refresh",

    // Modais Preventivas
    "ACAO": "ACTION",
    "PLACA": "PLATE",
    "PROXIMO_CICLO": "NEXT_CYCLE",
    "VENCIMENTO": "DUE_DATE",
    "PROXIMO_KM": "NEXT_KM",
    "KM_ATUAL": "CURRENT_KM",
    "Vincular Fornecedor": "Link Supplier",
    
    // Inventário
    "Não contados": "Not counted",
    "Contados": "Counted",
    "Ordenação": "Sorting",
    "Total Itens": "Total Items",
    "Status": "Status",
    "Inventário criado com sucesso!": "Inventory created successfully!",
    "Já existe um inventário em execução": "An inventory is already in progress",
    "Deseja iniciar um novo inventário?": "Do you want to start a new inventory?",
    "Inventário de Estoque": "Stock Inventory",

    // Modal Mecanico
    "Informe os três primeiros dígitos do seu CPF para confirmar sua identidade":
        "Enter the first three digits of your CPF to confirm your identity",
    'Confirmar identidade': 'Confirm identity',

    "Erro do Motorista": "Driver Error",
    "Defeito não Encontrado": "Defect Not Found",

    "Informe o serviço": "Enter the service",
    "Insira os Itens": "Insert the Items",

    "Alterar Fornecedor": "Change Supplier",
    "Preventivas Armazém": "Warehouse Preventives",
    "Outros": "Others",
    "Ver Encerradas": "View Closed",
    "Tem dúvida?": "Any questions?",
    "Nenhuma OS aguardando aprovação": "No WO awaiting approval",
    "Aguardando Aprovação": "Awaiting Approval",

    "OS Preventivas Vencidas": "Overdue Preventive WOs",
    "OS Encerradas - Últimas 15 OS": "Closed WOs - Last 15",
    "DATA": 'DATE',

    'Precisa de Ajuda?': 'Need Help?',
    'Desejamos um ótimo 2024!': 'We wish you a great 2024!',
    
    'Bem vindo(a) ao Terminal da Borracharia!': 'Welcome to the Tire Shop Terminal!',
    'Realize a gestão de pneus pelo novo terminal da borracharia!':
        'Manage tires through the new tire shop terminal!',
    'Aderência Aferição 01': 'Grip Measurement 01',
    'Aderência Aferição 02': 'Grip Measurement 02',
    'de Calibragem': 'of Calibration',
    'Aferição': 'Measurement',
    'Movimentação/Troca': 'Movement/Replacement',
    'Descarte': 'Disposal',
    'Serviço': 'Service',
    'Borracharia': 'Tire Shop',
    'Placas': 'Plates',

    'AÇÃO': 'ACTION',
    'TIPO': 'TYPE',
    'CONJUNTO': 'SET',
    'AFERIÇÃO': 'MEASUREMENT',

    'Selecione um Pneu': 'Select a Tire',
    'Informar KM': 'Enter KM',
    'Informar Aferição': 'Enter Measurement',
    'Aferindo NR Fogo': 'Measuring Fire Code',
    'Última Aferição': 'Last Measurement',
    'Novas Aferições': 'New Measurements',
    'Última aferição NR fogo': 'Last Fire Code Measurement',
    'Registrar Aferições': 'Register Measurements',
    'Realizar avaliação': 'Perform evaluation',
    'Preditiva': 'Predictive',
    'Externas Armazém': 'External Warehouse',
    'Carrocerias à Vencer': 'Upcoming Bodyworks',
    
    'Problema': 'Issue',
    'Pendente': 'Pending',
    'Descartes': 'Disposals',
    
    'OS Preditiva': 'Predictive WO',
    'Gerar OS Preditiva': 'Generate Predictive WO',
    'Iniciar novo inventário': 'Start new inventory',
    'Dt Inicial': 'Start Date',
    'Dt Final': 'End Date',

    "Fora do Prazo": "Overdue",
    "Dentro do Prazo": "On Time",

    "CALIBRAGEM": "CALIBRATION",
    "Nunca feito": "Never done",
    "FOGO": "FIRE",
    "Informar Calibragem": "Enter Calibration",
    "Comece a digitar o nome do fornecedor para exibir na lista abaixo":
    "Start typing the supplier name to display in the list below",

    "Portugues": "Portuguese",
    "Mercosul": "Mercosur",
    "Ingles": "English",
    'Frances': "French",
    'Alemao': 'German',
    'Holandes': 'Dutch',
    'Espanhol': 'Spanish',

    
    "O ESFORÇO DE HOJE É O SUCESSO DE AMANHA": "TODAY'S EFFORT IS TOMORROW'S SUCCESS",

    // Daqui para baixo deve ser jogado nos demais arquivos

    "CODIGO OS": "CODE WO",
    "TODOS": "ALL",
    "Socorro em Rota pendente de atendimento": "Emergency service pending response",
    "FILTROS": "FILTERS",
    "Salvar Filtro": "Save Filter",
    "Motorista": "Driver",
    "Orçamento": "Budget",
    "Confirmar Orçamento": "Confirm Budget",
    "Deseja pausar esta OS para aguardar o orçamento?": "Do you want to pause this work order to await the quote?",
    "Valor": 'Value',
    "Pausar OS": 'Pause WO',
    "Comentarios": 'Comments',
    "Insira um comentário": 'Enter a comment',
    "Enviar OS": 'Send WO',
    "Selecione uma justificativa": 'Select a justification',
    "Anexos": 'Attachments',
    "OS Socorro em Rotas": 'Roadside Assistance',
    "Confirmar Cancelamento": 'Confirm Cancellation',
    "Buscar Placa": 'Search Plate',
    "Pesquisa de OS por placa": 'OS search by motherboard',
    "CONTRATO_CONCESSIONARIA": "CONCESSIONAIRE CONTRACT",
    
    "Ordem gerada com sucesso": "Order generated successfully",
    "Sucesso": "Success",
    "Selecionar Todos": "Select All",
    "Descrição": "Description",
    "Registrar Serviços": "Register Services",
    "Visualizar Itens": "View Items",
    "Clique no botão a direita para registrar as peças": "Click the button on the right to register the parts",
    
    "Selecionar técnico": "Select technician",
    "KM atual/Horimetro": "Current mileage/Hour meter",
    "Deseja inserir alguma imagem no atendimento": "Do you want to add an image to the service",
    "Para concluir a ação, selecione abaixo o técnico responsável": "To complete the action, select the responsible technician below.",
    "Trabalhando": "Working",
    "Matricula": "Registration",
    "Serviços registrado com sucesso": "Services successfully registered",
    "Função": "Function",
    "Enviar Anexos": "Send Attachments",
    "Gerar Preventiva Programada": "Generate Scheduled Preventive Maintenance",
    "OS Preventiva Programada": "Scheduled Preventive Care",
    "Finalize todas as peças e serviços para encerrar o atendimento": "Complete all parts and services to close the service order",
    "Insira um KM maior que o anterior": "Enter a kilometer higher than the previous one",
    "Insira um KM maior que o atual": "Enter a kilometer value greater than the current value",
    "Inserir anexos": "Insert attachments",
    "Planos Preventivos": "Preventive Plans",
    "Filtro": "Filter",
    "ULTIMA": "LAST",
    "Gerar Preditiva": "Generate Preventive",
    "Carregando": "Loading",
    "OS Preventiva Programada Armazém": "Scheduled Preventive Maintenance Warehouse",
    "Gerar OS Preventiva Programada": "Generate Scheduled Preventive Work Order",
    "OS Preventivas à Vencer": "Preventive Measures to Overcome",
    "OS de Transição": "Transition WO",

    "IMEDIATA": "IMMEDIATE",
    "EMERGENCIAL": "EMERGENCY",
    "ALTA": "HIGH",
    "MÉDIA": "MEDIUM",
    "LEVE": "LOW",

    "Registrar Tarefas": "Register Tasks",
    "Desbloqueia Empilhadeira": "Unlock Forklift",
    "OS Ag. Aprovação": "WO Pending Approval",
    "OS Internas Veículos": "Internal WO – Vehicles",
    "OS Internas Armazém": "Internal WO – Warehouse",
    "OS Reabertas": "Reopened WO",
    "Criticidade de OS Abertas": "Criticality of Open WO",
    "Top 20 Placas com mais OS": "Top 20 License Plates with Most WO",
    "Qtd OS": "WO Quantity",

    // Dashboard
    "Criticidade de OS abertas": "Open WO Criticality",
    "URGENTE": "URGENT",
    "PREVENTIVA": "PREVENTIVE",
    "CRITICIDADES": "CRITICALITIES",
    "Bem Vindo(a)": "Welcome",
    "Tenha acesso as principais": "Get access to the main",
    "informações da sua mecânica!": "information about your workshop!",
    "Ver OS internas": "View Internal WO",
    "OS TicketLog": "TicketLog WO",
    "OS Externas": "External WO",
    "OS Interna Veículos": "Internal WO Vehicles",
    "OS Interna Armazém": "Internal WO Warehouse",
    "Ranking dos Mecânicos": "Mechanic Ranking",
    "Tipo de OS": "WO Type",
    "Atendidas nos últimos 30 dias": "Served in the last 30 days",
    "TOP 20 Placas com mais OS": "TOP 20 Plates with Most WO",
    "Últimos 30 dias": "Last 30 days",
    "Placas com OS Externas": "Plates with External WO",
    "TOP 10 Problemas mais atendidos": "TOP 10 Most Attended Issues",
    "Nos últimos 30 dias": "In the last 30 days",
    "Status por Mecânico": "Status by Mechanic",
    "Produtividade": "Productivity",

    // ModalEncerradas
    "Filtros": "Filters",
    "NÚMERO": "NUMBER",
    "INÍCIO": "START",
    "FINAL": "END",
    "SEGMENTO": "SEGMENT",
    "PROBLEMA": "ISSUE",

    // Login
    "Acesso Rápido": "Quick Access",
    "ID": "ID",
    "CNPJ": "ID",
    "codigo_fornec": "code",
    "Para qual fornecedor você deseja enviar esta OS": "Which supplier would you like to send this order to",

    "DS_PREDITIVO": "PREVENTIVE DESCRIPTION",
    "FILTRO EMPRESA": "COMPANY FILTER",
    "Upload Arquivos": "Upload Files",
    "Cards": "Cards",
    "Colunas": "Columns",
    "ULTIMA MM": "LAST MM",
    "PRÓXIMA MM": "NEXT MM",
    "ULTIMA CAL": "LAST CAL",
    "PRÓXIMA CAL": "NEXT CAL",

    "ULTIMA MOVIMENTACAO": "LAST MOVEMENT", 
    "PRÓXIMA MOVIMENTACAO": "NEXT MOVEMENT",
    "N° FOGO": "FIRE CODE",
    "FILIAL": "BRANCH",
    "MARCA": "BRAND",
    "MEDIDA": "MEASURE",
    "MODELO": "MODEL",
    "POSIÇÃO": "POSITION",
}